var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useCanAdminFilespace } from '#hooks';
export const FilespaceAdminGuard = ({ children }) => {
    _react_refresh_temp_2();
    const { filespaceId = '', workspaceId = '' } = useParams();
    const { canAdminFilespace, isLoading } = useCanAdminFilespace({
        filespaceId,
        workspaceId,
    });
    if (isLoading) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking your privileges'), "data-testid": "checking-privileges", isFullHeight: true }) }));
    }
    if (canAdminFilespace) {
        return children;
    }
    return _jsx(Navigate, { to: `/workspaces` });
};
_react_refresh_temp_1 = FilespaceAdminGuard;
$RefreshReg$(_react_refresh_temp_1, "FilespaceAdminGuard");
_react_refresh_temp_2(FilespaceAdminGuard, "JoaaELQ+aT03invNgeSdzplMeAA=", false, () => [useParams, useCanAdminFilespace]);
